import React from "react";
import { CardElement } from "@stripe/react-stripe-js";
import { getString } from "../../utilities";
import OptionallyDisplayed from "../global/optionallyDisplayed";
import { getLangCode, language } from "../../config";

export default function PaymentFields({
  doesNotRequireCredit,
  setCreditComplete,
  submitErrors = null,
  setSubmitErrors,
  isNewSubscriber = false,
  isDisabled = false,
}) {
  const elementOptions = {
    disabled: isDisabled,
    ...(getLangCode() === language.default && { style: { base: { textTransform: "capitalize" } } }),
  };

  return (
    <>
      <div className="cta">{getString("subscribe.payment")}</div>

      <OptionallyDisplayed doDisplay={doesNotRequireCredit}>
        <div className="subscribe-required">{getString("subscribe.creditNotRequired")}</div>
      </OptionallyDisplayed>

      <OptionallyDisplayed doDisplay={isNewSubscriber || !doesNotRequireCredit}>
        <CardElement
          onChange={(data) => {
            setCreditComplete(data.complete);

            if (submitErrors) {
              setSubmitErrors(null);
            }
          }}
          options={elementOptions}
        />
      </OptionallyDisplayed>
    </>
  );
}
